module.exports = __webpack_public_path__ + "static/media/arrow-pink.b8bbdfe0.svg";